import React from 'react'
import {BrowserRouter, Routes, Route, Navigate, useLocation} from "react-router-dom";
import SessionContext, { SessionProvider } from '../contexts/SessionContext';

import Login from '../pages/Login'
import TrackList from '../pages/Tracks/List';
import UserList from '../pages/Users/List';


//Creating the Private Route component
const PrivateRoute = ({children}) => {
    let sessionContext = React.useContext(SessionContext);
    let location = useLocation();
    
    if (!sessionContext.sessionData) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }
    
    return children;
}

const Navigation=()=>(
    <SessionProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} /> 
                <Route path="/tracks" element={
                    <PrivateRoute>
                        <TrackList />
                    </PrivateRoute>
                } />
                <Route path="/users" element={
                    <PrivateRoute>
                        <UserList />
                    </PrivateRoute>
                } />
            </Routes>
        </BrowserRouter>
    </SessionProvider>
)

export default Navigation
